(function() {
	'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('extracciondatos', {
        	parent: 'app',
            url: '/extracciondatos?page&sort&search',
            data: {
            	authorities: ['ADMINISTRATIVO_GENERAL_SIDE','ADMINISTRATIVO_BACHILLERATO_SIDE','RESPONSABLE_SIDE'],
                pageTitle: 'Portal Docente'
            },
            views: {
                'content@': {
                    templateUrl: 'app/extracciondatos/extracciondatosportal.html',
                    controller: 'EXTRACCIONDATOSController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                type: '1',
                indice : '1',
                ic: false,
                iic: '0',
                anio: '0',
                aniostr: '',
                modelo: '0',
                nivel: '0',
                centro: '0',
                ep: false
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        type: $stateParams.type,
                        indice: $stateParams.indice,
                        ic: $stateParams.ic,
                        iic: $stateParams.iic,
                        anio: $stateParams.anio,
                        aniostr: $stateParams.aniostr,
                        modelo: $stateParams.modelo,
                        nivel: $stateParams.nivel,
                        centro: $stateParams.centro,
                        ep: $stateParams.ep
                    };
                }]
            }
        })
	}

})();
